import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { injectIntl, defineMessages } from 'react-intl';

import { replyToReview as replyToReviewAction } from '../Ratings.saga';
import ReplyToReviewForm from './ReplyToReviewForm';

const mapStateToProps = (state, ownProps) => ({ ...ownProps });

const messages = defineMessages({
  fieldRequired: {
    id: 'ratings.reply-to-review.validation-error.field-required',
    defaultMessage: 'This field is required.',
  },
});

const validate = (values, props) => {
  const {
    intl: { formatMessage },
  } = props;
  const errors = {};
  if (!values.response) {
    errors.response = formatMessage(messages.fieldRequired);
  }

  return errors;
};

const mapDispatchToProps = {
  replyToReview: replyToReviewAction,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { reviewId } = stateProps;
  const { replyToReview } = dispatchProps;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSubmit: replyToReview.bind(null, reviewId),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  injectIntl,
  reduxForm({
    validate,
  })
)(ReplyToReviewForm);
